import { render, staticRenderFns } from "./AttachmentPortEdit.vue?vue&type=template&id=793d6043&"
import script from "./AttachmentPortEdit.vue?vue&type=script&lang=js&"
export * from "./AttachmentPortEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports